import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBorderTopBottomThick$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBorderTopBottomThick extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-border-top-bottom-thick", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M5.1213 5.52194C5.29086 5.21098 5.62071 5 5.99984 5H14.0001C14.3792 5 14.7091 5.21102 14.8787 5.52202L14.8846 5.5178C15.0256 5.75079 15.2608 5.92562 15.5492 5.98169C16.0913 6.08705 16.6161 5.73305 16.7214 5.19102C16.7815 4.88221 16.6924 4.57898 16.5044 4.35573L16.508 4.35312C15.9717 3.53804 15.0487 3 14.0001 3H5.99984C4.95123 3 4.02827 3.538 3.49194 4.35304L3.4956 4.35566C3.30761 4.57891 3.21854 4.88213 3.27857 5.19094C3.38393 5.73297 3.90875 6.08697 4.45078 5.98161C4.7392 5.92554 4.97438 5.75072 5.11544 5.51773L5.1213 5.52194ZM5.1213 14.4783C5.29086 14.7893 5.62071 15.0002 5.99984 15.0002H14.0001C14.3792 15.0002 14.7091 14.7892 14.8787 14.4782L14.8846 14.4824C15.0256 14.2495 15.2608 14.0746 15.5492 14.0186C16.0913 13.9132 16.6161 14.2672 16.7214 14.8092C16.7815 15.118 16.6924 15.4213 16.5044 15.6445L16.508 15.6471C15.9717 16.4622 15.0487 17.0002 14.0001 17.0002H5.99984C4.95123 17.0002 4.02827 16.4622 3.49194 15.6472L3.4956 15.6446C3.30761 15.4213 3.21854 15.1181 3.27857 14.8093C3.38393 14.2673 3.90875 13.9133 4.45078 14.0186C4.7392 14.0747 4.97438 14.2495 5.11544 14.4825L5.1213 14.4783ZM4 11.9998C3.44772 11.9998 3 11.552 3 10.9998V8.99976C3 8.44747 3.44772 7.99976 4 7.99976C4.55228 7.99976 5 8.44747 5 8.99976V10.9998C5 11.552 4.55228 11.9998 4 11.9998ZM15 10.9998C15 11.552 15.4477 11.9998 16 11.9998C16.5523 11.9998 17 11.552 17 10.9998V8.99976C17 8.44747 16.5523 7.99976 16 7.99976C15.4477 7.99976 15 8.44747 15 8.99976V10.9998Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-border-top-bottom-thick-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-border-top-bottom-thick", "wpp-icon-border-top-bottom-thick-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-border-top-bottom-thick-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-border-top-bottom-thick-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBorderTopBottomThick$1);
      }
      break;
  } });
}

const WppIconBorderTopBottomThick = WppIconBorderTopBottomThick$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBorderTopBottomThick, defineCustomElement };
